import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: "f3b18536-d91a-49cf-9598-c7cb3ce0dd4c", 
    authority: "https://login.microsoftonline.com/5ba5ef5e-3109-4e77-85bd-cfeb0d347e82",
    redirectUri: "https://libfrontdesk.nus.edu.sg/dashboard", // Must match Azure portal
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};
 
export const loginRequest = {
  scopes: ["User.Read"],
};

export const msalInstance = new PublicClientApplication(msalConfig);